import { HTMLAttributes, ReactElement } from 'react'

import Breadcrumbs, { BreadcrumbProps } from '@/components/base/breadcrumbs'
import Grid from '@/components/base/grid'

import { cn } from '@/lib/utils'

export type HeadingProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    schema: BreadcrumbProps['schema']
    search?: ReactElement | null
    tools?: ReactElement | null
  }>

const Heading = ({ schema, children, search, className, tools, ...props }: HeadingProps) => {
  return (
    <Grid
      className={cn('col-span-2 gap-y-[3rem] md:col-span-6 lg:col-span-12', className)}
      {...props}
    >
      <div className={cn('col-span-2 md:col-span-3 lg:col-span-6', 'grid gap-y-[3rem]')}>
        {schema ? <Breadcrumbs schema={schema} /> : null}
        {children}
      </div>

      {search ? (
        <div className={cn('col-span-2 md:col-span-3 lg:col-span-6', 'flex items-end justify-end')}>
          {search}
        </div>
      ) : null}

      {tools ? (
        <div
          className={cn('col-span-2 md:col-span-3 lg:col-span-6', 'flex items-end md:justify-end')}
        >
          {tools}
        </div>
      ) : null}
    </Grid>
  )
}

export default Heading
